import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

import { $qs, $qsa } from "../../src/js/utils/querySelector";

gsap.registerPlugin(ScrollTrigger);

function nav() {
	var hamburgerToggle = $qs('[data-js="toggle-main-menu"]');
	var hamburgerLine1 = $qs('[data-name="hamburger-line-1"]');
	var hamburgerLine2 = $qs('[data-name="hamburger-line-2"]');
	var mainMenu = $qs('[data-name="main-menu"]');
	var mainMenuBg = $qs('[data-name="main-menu-bg"]');

	// Get the proper menu text element based on the nav style
	const navStyle = getNavStyle();
	var menuText;

	// For top-nav-5, the span is the third child of the hamburger toggle
	if (navStyle === "top-nav-5") {
		menuText = hamburgerToggle.querySelector("span:nth-child(3)");
	} else {
		// Existing selection for top-nav-1
		menuText = $qs('[data-js="toggle-main-menu"] span');
	}

	const backButtons = $qsa('[data-js="back-to-main-menu"]');
	var logoLink = $qs('[data-name="logo-link"]');
	var bottomNavButtons = $qs('[data-name="bottom-nav-buttons"]');
	var topNav = $qs(".top-nav");

	// Tonbridge sites dropdown functionality
	const tonbridgeSitesToggle = $qs('[data-js="tonbridge-sites-toggle"]');
	const tonbridgeSitesDropdown = $qs('[data-name="tonbridge-sites-dropdown"]');
	const tonbridgeSitesWrapper = $qs(".tonbridge-sites-wrapper");

	if (tonbridgeSitesWrapper && tonbridgeSitesDropdown) {
		// Show dropdown on hover - use separate mouse events for more reliable hovering
		tonbridgeSitesWrapper.addEventListener("mouseover", () => {
			gsap.to(tonbridgeSitesDropdown, {
				opacity: 1,
				visibility: "visible",
				duration: 0.2,
				ease: "power1.out",
			});
		});
		// Hide dropdown when mouse leaves
		tonbridgeSitesWrapper.addEventListener("mouseout", () => {
			// Only hide if it doesn't have the active class (from mobile click)
			if (!tonbridgeSitesDropdown.classList.contains("active")) {
				gsap.to(tonbridgeSitesDropdown, {
					opacity: 0,
					visibility: "hidden",
					duration: 0.2,
					ease: "power1.in",
				});
			}
		});

		// Add click functionality for mobile
		tonbridgeSitesToggle.addEventListener("click", () => {
			if (tonbridgeSitesDropdown.classList.contains("active")) {
				gsap.to(tonbridgeSitesDropdown, {
					opacity: 0,
					visibility: "hidden",
					duration: 0.3,
					onComplete: () => {
						tonbridgeSitesDropdown.classList.remove("active");
					},
				});
			} else {
				tonbridgeSitesDropdown.classList.add("active");
				gsap.to(tonbridgeSitesDropdown, {
					opacity: 1,
					visibility: "visible",
					duration: 0.3,
				});
			}
		});
	}

	if (topNav && $qs("footer")) {
		// Store the original top position when the page loads
		let originalTopPosition =
			window.scrollY + topNav.getBoundingClientRect().top;

		// // Check if screen width is greater than 992px
		// if (window.innerWidth > 992) {
		//     ScrollTrigger.create({
		//         trigger: 'footer',
		//         start: 'top bottom',
		//         end: 'bottom bottom',
		//         onEnter: () => {
		//             // Get the current position right when entering the footer
		//             originalTopPosition = window.scrollY + topNav.getBoundingClientRect().top;

		//             gsap.set(topNav, {
		//                 position: 'absolute',
		//                 bottom: 'auto',
		//                 top: originalTopPosition,
		//                 right:0,
		//             });
		//         },
		//         onLeaveBack: () => {
		//             gsap.set(topNav, {
		//                 position: 'fixed',
		//                 top: 0,
		//                 bottom: 'auto',
		//                 right:0,
		//             });
		//         }
		//     });
		// }
	}

	// Update the getNavStyle function to correctly identify top-nav-5
	function getNavStyle() {
		// More reliable way to detect top-nav-5
		// Check for the distinctive structure of top-nav-5
		if (document.querySelector(".topnavburger")) {
			return "top-nav-5";
		}
		return "top-nav-1"; // Default to top-nav-1 behavior
	}

	var menuOpen = false;
	var subMenuOpen = false;
	let menuTimeline = gsap.timeline();
	menuTimeline.pause();

	// Initialize elements to their starting positions
	menuTimeline.set(mainMenu, { xPercent: 0 });
	menuTimeline.set(mainMenuBg, { autoAlpha: 0 });
	menuTimeline.set(".sub-menu-wrap", { xPercent: 0, opacity: 0 });

	// Animate to open positions
	menuTimeline.to("body", {
		overflow: "hidden",
		duration: 0,
		onStart: () => {
			document.body.classList.add("menuactv");
		},
	});
	menuTimeline.to(
		hamburgerLine1,
		{
			rotate: -45,
			width:
				window.innerWidth >= 768 && window.innerWidth <= 1535 ? "36px" : "46px",
			duration: 0.5,
			//backgroundColor: "#132A3E",
		},
		"<"
	);
	menuTimeline.to(
		menuText,
		{
			duration: 0.5,
			//color: "#132A3E",
		},
		"<"
	);
	menuTimeline.to(
		hamburgerLine2,
		{
			rotate: 45,
			width:
				window.innerWidth >= 768 && window.innerWidth <= 1535 ? "36px" : "46px",
			duration: 0.5,
			//backgroundColor: "#132A3E",
		},
		"<"
	);
	menuTimeline.to(
		mainMenu,
		{
			xPercent:
				window.innerWidth < 992
					? -100
					: document.body.classList.contains("site-id-1")
					? -55
					: -100,
			pointerEvents: "auto",
			duration: 0.5,
			ease: "power2.inOut",
		},
		"<"
	);
	menuTimeline.to(
		mainMenuBg,
		{
			autoAlpha: 1,
			duration: 0.5,
		},
		"<"
	);
	menuTimeline.to(
		logoLink,
		{
			//backgroundColor: "transparent",
			duration: 1,
		},
		"<"
	);

	hamburgerToggle?.addEventListener("click", (event) => {
		if (!menuOpen) {
			menuOpen = true;
			document.body.classList.add("menuactv");
			menuTimeline.restart();

			// Use the correct menuText element based on nav style
			if (navStyle === "top-nav-5") {
				hamburgerToggle.querySelector("span:nth-child(3)").textContent =
					"Close";
			} else {
				menuText.textContent = "Close";
			}
			hamburgerToggle.classList.add("hamburger-open");
			if (bottomNavButtons) {
				bottomNavButtons.classList.add("actv");
			}

			// Check if current page is in a submenu
			const currentPath = window.location.pathname;
			const topLevelMenuItems = $qsa(".main-menu > .menu-item");

			// Skip submenu auto-opening for homepage
			if (currentPath !== "/" && currentPath !== "") {
				let foundSubmenu = false;
				topLevelMenuItems.forEach((menuItem) => {
					const subMenu = $qs(".sub-menu-wrap", menuItem);
					if (subMenu) {
						const subMenuLinks = $qsa("a", subMenu);
						const isCurrentPageInSubMenu = Array.from(subMenuLinks).some(
							(link) => {
								const linkPath = new URL(link.href).pathname;
								// Handle trailing slashes and exact matches
								return (
									currentPath === linkPath ||
									currentPath === linkPath + "/" ||
									currentPath + "/" === linkPath
								);
							}
						);

						if (isCurrentPageInSubMenu) {
							foundSubmenu = true;
							// Open the submenu
							subMenuOpen = true;
							menuItem.classList.add("menu-item-active");

							// Add submenu animation to the main timeline with a slight offset
							menuTimeline.to(
								subMenu,
								{
									xPercent: window.innerWidth < 992 ? -100 : -20,
									pointerEvents: "auto",
									opacity: 1,
									duration: 0.4,
									ease: "power2.inOut",
									onStart: () => {
										// Ensure submenu is visible and properly positioned
										gsap.set(subMenu, {
											visibility: "visible",
											display: "flex",
										});
									},
								},
								"-=0.3"
							); // Start slightly before main menu animation completes

							// Highlight the current page link
							subMenuLinks.forEach((link) => {
								const linkPath = new URL(link.href).pathname;
								if (
									currentPath === linkPath ||
									currentPath === linkPath + "/" ||
									currentPath + "/" === linkPath
								) {
									link.classList.add("current-menu-item");
								}
							});
						}
					}
				});

				// If we found a submenu, adjust the main menu position
				if (foundSubmenu) {
					menuTimeline.to(
						mainMenu,
						{
							xPercent: -100,
							duration: 0.5,
							ease: "power2.inOut",
						},
						"<"
					);
				}
			}
		} else {
			// Create a timeline for coordinated animations
			const closeTimeline = gsap.timeline();

			// Add all animations to the timeline
			closeTimeline.to("body", {
				overflow: "auto",
				duration: 0,
				onStart: () => {
					document.body.classList.remove("menuactv");
				},
			});

			closeTimeline.to(
				hamburgerLine1,
				{
					rotate: 0,
					width:
						window.innerWidth >= 768 && window.innerWidth <= 1535
							? "36px"
							: "46px",
					duration: 0.5,
					//backgroundColor: "#132A3E",
				},
				0
			);

			closeTimeline.to(
				menuText,
				{
					duration: 0.5,
					//color: "#132A3E",
				},
				0
			);

			closeTimeline.to(
				hamburgerLine2,
				{
					rotate: 0,
					width:
						window.innerWidth >= 768 && window.innerWidth <= 1535
							? "36px"
							: "46px",
					duration: 0.5,
					//backgroundColor: "#132A3E",
				},
				0
			);

			closeTimeline.to(
				mainMenu,
				{
					xPercent: 0,
					pointerEvents: "none",
					duration: 0.5,
					ease: "power2.inOut",
				},
				0
			);

			closeTimeline.to(
				mainMenuBg,
				{
					autoAlpha: 0,
					duration: 0.5,
				},
				0
			);

			closeTimeline.to(
				logoLink,
				{
					//backgroundColor: "#fff",
					duration: 1,
				},
				0
			);

			// Reset top level menu items
			var topLevelMenuItems = $qsa(".main-menu > .menu-item");
			topLevelMenuItems.forEach((topLevelItem) => {
				topLevelItem.classList.remove("menu-item-active");
				closeTimeline.to(
					$qs("a", topLevelItem),
					{
						color: "#132A3E",
						duration: 0.5,
					},
					0
				);
			});

			// Reset any open submenus with proper transform reset
			if (subMenuOpen) {
				closeTimeline.to(
					".sub-menu-wrap",
					{
						xPercent: 100,
						pointerEvents: "none",
						opacity: 0,
						duration: 0.5,
						onComplete: () => {
							gsap.set(".sub-menu-wrap", { xPercent: 0 });
						},
					},
					0
				);
			}

			// Update menu state
			menuOpen = false;
			document.body.classList.remove("menuactv");
			subMenuOpen = false;
			if (bottomNavButtons) {
				bottomNavButtons.classList.remove("actv");
			}

			// Update menu text
			if (navStyle === "top-nav-5") {
				hamburgerToggle.querySelector("span:nth-child(3)").textContent = "Menu";
			} else {
				menuText.textContent = "Menu";
			}

			hamburgerToggle.classList.remove("hamburger-open");
		}
	});

	// Initialize sub-menu-wrap elements with opacity 0
	const subMenuWraps = $qsa(".sub-menu-wrap");
	if (subMenuWraps.length) {
		gsap.set(subMenuWraps, {
			opacity: 0,
			pointerEvents: "none",
		});
	}
	// Uncomment and improve the body click handler
	$qs("body").addEventListener("click", (event) => {
		// Check if menu is open and the click is outside the menu components
		if (
			menuOpen &&
			!mainMenu.contains(event.target) &&
			!hamburgerToggle.contains(event.target) &&
			!event.target.closest('[data-name="main-menu-bg"]')
		) {
			// Create a timeline for coordinated animations
			const closeTimeline = gsap.timeline();

			// Add all animations to the timeline
			closeTimeline.to("body", {
				overflow: "auto",
				duration: 0,
				onStart: () => {
					document.body.classList.remove("menuactv");
				},
			});

			closeTimeline.to(
				hamburgerLine1,
				{
					rotate: 0,
					width:
						window.innerWidth >= 768 && window.innerWidth <= 1535
							? "36px"
							: "46px",
					duration: 0.5,
					//backgroundColor: "#132A3E",
				},
				0
			);

			closeTimeline.to(
				menuText,
				{
					duration: 0.5,
					//color: "#132A3E",
				},
				0
			);

			closeTimeline.to(
				hamburgerLine2,
				{
					rotate: 0,
					width:
						window.innerWidth >= 768 && window.innerWidth <= 1535
							? "36px"
							: "46px",
					duration: 0.5,
					//backgroundColor: "#132A3E",
				},
				0
			);

			closeTimeline.to(
				mainMenu,
				{
					xPercent: 0,
					pointerEvents: "none",
					duration: 0.5,
					ease: "power2.inOut",
				},
				0
			);

			closeTimeline.to(
				mainMenuBg,
				{
					autoAlpha: 0,
					duration: 0.5,
				},
				0
			);

			closeTimeline.to(
				logoLink,
				{
					//backgroundColor: "#fff",
					duration: 1,
				},
				0
			);

			// Reset top level menu items
			var topLevelMenuItems = $qsa(".main-menu > .menu-item");
			topLevelMenuItems.forEach((topLevelItem) => {
				topLevelItem.classList.remove("menu-item-active");
				closeTimeline.to(
					$qs("a", topLevelItem),
					{
						color: "#132A3E",
						duration: 0.5,
					},
					0
				);
			});

			// Reset any open submenus with proper transform reset
			if (subMenuOpen) {
				closeTimeline.to(
					".sub-menu-wrap",
					{
						xPercent: 100,
						pointerEvents: "none",
						opacity: 0,
						duration: 0.5,
						onComplete: () => {
							gsap.set(".sub-menu-wrap", { xPercent: 0 });
						},
					},
					0
				);
			}

			// Update menu state
			menuOpen = false;
			document.body.classList.remove("menuactv");
			subMenuOpen = false;
			if (bottomNavButtons) {
				bottomNavButtons.classList.remove("actv");
			}

			// Update menu text
			if (navStyle === "top-nav-5") {
				hamburgerToggle.querySelector("span:nth-child(3)").textContent = "Menu";
			} else {
				menuText.textContent = "Menu";
			}

			hamburgerToggle.classList.remove("hamburger-open");
		}
	});

	var mainMenuContainer = $qs(".main-menu");

	var topLevelMenuItems = $qsa(".main-menu > .menu-item");
	topLevelMenuItems.forEach((menuItem) => {
		let menuItemLink = $qs("a", menuItem);
		// if(menuOpen) {
		menuItemLink.addEventListener("click", (event) => {
			if (menuItem.classList.contains("menu-item-active")) {
				event.preventDefault();
				menuItem.classList.remove("menu-item-active");
				gsap.to(menuItemLink, {
					color: "#132A3E",
					duration: 0.5,
				});
				gsap.to(mainMenu, {
					xPercent: -50,
				});
				gsap.to(".sub-menu-wrap", {
					xPercent: 0,
					pointerEvents: "none",
					opacity: 0,
					duration: 0.5,
				});
				subMenuOpen = false;
				return;
			}

			topLevelMenuItems.forEach((topLevelItem) => {
				topLevelItem.classList.remove("menu-item-active");
				gsap.to($qs("a", topLevelItem), {
					color: "#132A3E",
					duration: 0.5,
				});
			});
			if (menuItem.classList.contains("menu-item-has-children")) {
				subMenuOpen = true;
				event.preventDefault();
				// Close all sub menus
				var subMenus = $qsa(".sub-menu-wrap");
				var subMenuLists = $qsa(".sub-menu-wrap li");
				gsap.to(subMenus, {
					xPercent: 0,
					pointerEvents: "none",

					opacity: 0,
				});
				// Open the clicked sub menu
				let subMenu = $qs(".sub-menu-wrap", menuItem);
				let subMenuList = $qsa(".sub-menu-wrap li", menuItem);
				gsap.to(mainMenu, {
					xPercent: -100,
					// pointerEvents: 'none',
				});
				gsap.to(subMenu, {
					xPercent: window.innerWidth < 992 ? -100 : -20,
					pointerEvents: "auto",
					opacity: 1,
					duration: 0.5,
				});
				gsap.to(menuItemLink, {
					color: "#1DADCE",
					duration: 0.5,
				});

				menuItem.classList.add("menu-item-active");
			}

			if (subMenuOpen) {
				let subMenuParents = $qsa(".menu-item-has-children", menuItem);
				console.log(subMenuParents);
				subMenuParents.forEach((accordion) => {
					var accordionTrigger = $qs("a", accordion);
					var accordionContent = $qs(".accordion-menu", accordion);
					var state = "closed";

					// Remove existing event listener if any
					accordionTrigger.removeEventListener("click", handleAccordionClick);

					// Define the click handler function
					function handleAccordionClick(event) {
						event.preventDefault();
						closeAllMenuAccordions(
							subMenuParents,
							event.currentTarget.parentNode
						);

						if (state === "closed") {
							state = "open";
							accordion.classList.add("menu-accordion-open");
							gsap.to(accordionContent, { height: "auto", duration: 0.5 });
						} else {
							state = "closed";
							accordion.classList.remove("menu-accordion-open");
							gsap.to(accordionContent, { height: 0, duration: 0.5 });
						}
					}

					// Add the click event listener
					accordionTrigger.addEventListener("click", handleAccordionClick);
				});
			}
		});

		// }
	});

	function closeAllMenuAccordions(accordions, clickedAccordion) {
		accordions.forEach((accordion) => {
			if (accordion === clickedAccordion) return; // skip the clicked accordion

			var accordionContent = $qs(".accordion-menu", accordion);
			accordion.classList.remove("menu-accordion-open");
			gsap.to(accordionContent, { height: 0, duration: 0.5 });
			// gsap.to(accordion.querySelector('.icon .plus-vertical'), { rotate: '0deg', transformOrigin: 'center', duration: 0.5 });
		});
	}

	backButtons.forEach((backButton) => {
		backButton.addEventListener("click", () => {
			var topLevelMenuItems = $qsa(".main-menu > .menu-item");
			topLevelMenuItems.forEach((topLevelItem) => {
				topLevelItem.classList.remove("menu-item-active");
				gsap.to($qs("a", topLevelItem), {
					color: "#132A3E",
					duration: 0.5,
				});
			});

			gsap.to(mainMenu, {
				xPercent:
					window.innerWidth < 992
						? -100
						: document.body.classList.contains("site-id-1")
						? -55
						: -100,
				pointerEvents: "none",
				duration: 0.5,
				ease: "power2.inOut",
			});
			gsap.to(".sub-menu-wrap", {
				xPercent: 0,
				pointerEvents: "none",
				opacity: 0,
				duration: 0.5,
			});
			subMenuOpen = false;
		});
	});

	if (subMenuOpen) {
		// Handle all menu items with children in the submenu
		const subMenuItemsWithChildren = document.querySelectorAll(
			".sub-menu li.menu-item-has-children > a"
		);

		subMenuItemsWithChildren.forEach((itemLink) => {
			const menuItemWithChildren = itemLink.parentElement;
			const accordionContent =
				menuItemWithChildren.querySelector(".accordion-menu");

			// Remove any existing event listeners
			const newItemLink = itemLink.cloneNode(true);
			itemLink.parentNode.replaceChild(newItemLink, itemLink);

			newItemLink.addEventListener("click", (event) => {
				event.preventDefault();
				event.stopPropagation();

				// Close all other open accordions
				document
					.querySelectorAll(".sub-menu li.menu-item-has-children")
					.forEach((otherItem) => {
						if (otherItem !== menuItemWithChildren) {
							otherItem.classList.remove("menu-accordion-open");
							const otherContent = otherItem.querySelector(".accordion-menu");
							if (otherContent) {
								gsap.to(otherContent, { height: 0, duration: 0.5 });
							}
						}
					});

				// Toggle current accordion
				if (menuItemWithChildren.classList.contains("menu-accordion-open")) {
					menuItemWithChildren.classList.remove("menu-accordion-open");
					gsap.to(accordionContent, { height: 0, duration: 0.5 });
				} else {
					menuItemWithChildren.classList.add("menu-accordion-open");
					gsap.to(accordionContent, { height: "auto", duration: 0.5 });
				}
			});
		});
	}
	// Prevent default behavior for menu items with children
	const subMenuItemsWithChildren = document.querySelectorAll(
		".sub-menu li.menu-item-has-children > a"
	);
	subMenuItemsWithChildren.forEach((item) => {
		item.addEventListener("click", (e) => {
			e.preventDefault();

			const menuItem = item.parentElement;
			const accordionMenu = menuItem.querySelector(".accordion-menu");

			// Close all other open accordions first
			document
				.querySelectorAll(".sub-menu li.menu-item-has-children")
				.forEach((otherItem) => {
					if (
						otherItem !== menuItem &&
						otherItem.classList.contains("menu-accordion-open")
					) {
						otherItem.classList.remove("menu-accordion-open");
						const otherAccordion = otherItem.querySelector(".accordion-menu");
						if (otherAccordion) {
							gsap.to(otherAccordion, { height: 0, duration: 0.5 });
						}
					}
				});

			// Toggle current accordion
			if (menuItem.classList.contains("menu-accordion-open")) {
				// Close accordion
				menuItem.classList.remove("menu-accordion-open");
				gsap.to(accordionMenu, { height: 0, duration: 0.5 });
			} else {
				// Open accordion
				menuItem.classList.add("menu-accordion-open");
				gsap.to(accordionMenu, { height: "auto", duration: 0.5 });
			}
		});
	});
}

export default nav;
